import { CommonModule, DecimalPipe } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterModule } from '@angular/router';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { DynamicFormBuilderModule } from '../dynamic-form-builder/dynamic-form-builder.module';
import { FirestoreModule } from '../modules/firestore.module';
import { MaterialModule } from '../modules/material.module';
import { AdsComponent } from './components/ads/ads.component';
import { CreateDialogComponent } from './components/create-dialog/create-dialog.component';
import { FieldComponent } from './components/field/field.component';
import { FooterComponent } from './components/footer/footer.component';
import { LandingComponent } from './components/landing/landing.component';
import { LangComponent } from './components/lang/lang.component';
import { ModalComponent } from './components/modal/modal.component';
import { SidemenuComponent } from './components/sidemenu/sidemenu.component';
import { SkeletonComponent } from './components/skeleton/skeleton.component';
import { TypeProductComponent } from './components/type-product/type-product.component';
import { UploadDocumentComponent } from './components/upload-document/upload-document.component';
import { PreloadImgComponent } from './directives/preload-img/preload-img.component';
import { PreloadImgDirective } from './directives/preload.directive';
import { TruncateSafeHtmlPipe } from './pipes/description.pipe';
import { FilterElementsPipe } from './pipes/filter-elements.pipe';
import { FirstUppercasePipe } from './pipes/first-uppercase.pipe';
import { TypeNumberPipe } from './pipes/type-number.pipe';

/**
 * Modulo CORE de la apliacion
 */
@NgModule({ declarations: [
        FooterComponent,
        FieldComponent,
        UploadDocumentComponent,
        SkeletonComponent,
        CreateDialogComponent,
        AdsComponent,
        TypeNumberPipe,
        FilterElementsPipe,
        TruncateSafeHtmlPipe,
        FirstUppercasePipe,
        PreloadImgDirective,
        LandingComponent,
        PreloadImgComponent,
        SidemenuComponent,
        LangComponent,
        ModalComponent,
        TypeProductComponent,
    ],
    exports: [
        CommonModule,
        FilterElementsPipe,
        TruncateSafeHtmlPipe,
        TypeNumberPipe,
        FirstUppercasePipe,
        FooterComponent,
        SkeletonComponent,
        NgxSkeletonLoaderModule,
        ReactiveFormsModule,
        CreateDialogComponent,
        DynamicFormBuilderModule,
        MaterialModule,
        MatProgressSpinnerModule,
        AdsComponent,
        PreloadImgDirective,
        UploadDocumentComponent,
        FormsModule,
        GoogleMapsModule,
        PreloadImgComponent,
        SidemenuComponent,
        TypeProductComponent
    ], imports: [CommonModule,
        RouterModule,
        NgxSkeletonLoaderModule,
        DynamicFormBuilderModule,
        MaterialModule,
        MatProgressSpinnerModule,
        ReactiveFormsModule,
        FormsModule,
        FirestoreModule,
        GoogleMapsModule], providers: [DecimalPipe, FirstUppercasePipe, provideHttpClient(withInterceptorsFromDi())] })
export class CoreModule { }
